import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { statusColours } from '../../constants/ColourConstants';

import IconButton from 'material-ui/IconButton';

import IconMenu from 'material-ui/IconMenu';

import LinearProgress from 'material-ui/LinearProgress';
import { ListItem } from 'material-ui/List';

import InfoIcon from 'material-ui/svg-icons/action/info';
import LaunchIcon from 'material-ui/svg-icons/action/launch';
import SubjectIcon from 'material-ui/svg-icons/action/subject';
import LibraryIcon from 'material-ui/svg-icons/av/library-books';
import VideoIcon from 'material-ui/svg-icons/av/video-library';
import AudioIcon from 'material-ui/svg-icons/av/library-music';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import PrivateIcon from 'material-ui/svg-icons/action/lock';
import SkillIcon from 'material-ui/svg-icons/social/public';
import CPDIcon from 'material-ui/svg-icons/toggle/star';
import DoneIcon from 'material-ui/svg-icons/action/done';
import DoneAllIcon from 'material-ui/svg-icons/action/done-all';
import SchoolIcon from 'material-ui/svg-icons/social/school';
import SpotIcon from 'material-ui/svg-icons/image/lens';

import buildContextMenu from '../Common/BuildContextMenu';


const style = {
    menu: {
        marginRight: 0,
        marginBottom: 0,
        float: 'left',
        position: 'relative',
        zIndex: 0,
    },
    menuItem: {
        color: '#CC0000',
    },
    iconButton: {
        marginRight: 0,
    },
    listItem: {
        padding: '2px',
    },
    icon: {
        height: '32px',
        width: '32px',
    }
};

const MyModuleListItem = React.createClass({


    getActions: function(row) {
        const infoLink       = '/dashboard/module/' + row.id;

        return [
            {
                link: infoLink,
                label: 'Preview',
                icon: <InfoIcon />
            }
        ];
    },

    render: function() {

        const row = this.props.data;
        const infoLink = this.props.link || `/dashboard/module/${row.id}`;
        const menuItems = buildContextMenu((this.props.actions || this.getActions(row)), this.context.auth);

        let listItemProps = {
            key: row.id,
            style: style.listItem
        };

        listItemProps.primaryText = (<Link to={infoLink} className="primaryText">{row.name}</Link>);

        let description = '';

        let displayDuration = '';
        const duration =  parseInt(row.duration);
        if (duration > 0) {
            let hours = Math.floor( duration / 60);
            let minutes = duration % 60;

            if (hours > 0) {
                displayDuration = hours + 'h';
                if (minutes > 0) {
                    displayDuration += ' ' + minutes + 'm';
                }
            } else if (minutes > 0) {
                displayDuration = minutes + 'm';
            }
        }

        if (row.skillId) {
            description   = row.skillName + ' - ' + row.skillLevel;
        } else {
            description = (row.type + displayDuration);
        }

        const enrolmentMethod = (row.isAssigned ? 'Assigned' : 'Booked');

        let iconColor = statusColours.default;

        let iconGroup = [];
        if (row.visibility === 'private') {
            iconGroup.push(<PrivateIcon className="icon-small"  key="visibility" />);
        }

        if (row.skillId) {
            iconGroup.push(<SkillIcon className="icon-small"  key="skill" />);
        }

        if (Number(row.cpdCredits)) {
            iconGroup.push(<CPDIcon className="icon-small"  key="cpd" />);
        }

        if (row.isAssigned) {
            if (row.isMandatory) {
                iconGroup.push(<SpotIcon className="icon-small" color={statusColours.mandatory} key="mandatory"/>);
            } else {
                iconGroup.push(<SpotIcon className="icon-small" color={statusColours.optional} key="optional"/>);
            }
        }

        switch(row.enrolmentStatus) {

            case 'waiting':
                description  = 'On waiting list';
                iconColor = statusColours.waiting;
                break;

            case 'enrolled':
                description = enrolmentMethod;
                iconColor = statusColours.enrolled;
                iconGroup.push(<DoneIcon className="icon-small"  key="enrolled" />);

                if (!!row.enrolmentDate) {
                    const enrolmentDate = new Date(row.enrolmentDate);
                    if (!!enrolmentDate && !isNaN(enrolmentDate.valueOf())) {
                        description += ` on ${enrolmentDate.toDateString()}`;
                    }
                }

                break;

            case 'completed':

                description = 'Completed';
                iconColor = statusColours.completed;

                let passed  = false;

                if (row.type === 'resource' || row.type === 'video' || row.type === 'audio') {
                    passed = true;
                } else {

                    if (row.required > 0) {

                        if (row.enrolmentScore && row.enrolmentScore >= row.required) {
                            passed = true;
                            description = 'Passed';
                        }

                    } else {
                        passed = true;
                        description = 'Passed';
                    }
                }

                if (passed) {
                    iconGroup.push(<DoneAllIcon className="icon-small"  color={statusColours.primary} key="done" />);
                } else {
                    iconGroup.push(<DoneIcon className="icon-small"  color={statusColours.primary } key="done" />);
                }

                if (!!row.completedDate) {
                    const completedDate = new Date(row.completedDate);
                    if (!!completedDate && !isNaN(completedDate.valueOf())) {
                        description += ` on ${completedDate.toDateString()}`;
                    }
                }

                break;

            case 'cancelled':
                iconColor = statusColours.cancelled;
                description = 'Cancelled';
                break;

            default:
                break;
        }


        if (row.loading) {
            listItemProps.secondaryText = <div><LinearProgress mode="indeterminate"/></div>;
        } else {
            listItemProps.secondaryText = (
                <Link to={infoLink} className="secondaryText">
                    <em>{description}</em>
                    <br />
                    {iconGroup}
                </Link>
            );
            listItemProps.secondaryTextLines = 2;
        }

        if (menuItems.length > 0) {
            const topRight = {horizontal: 'right', vertical: 'top'};
            const iconMenuProps = {
                menuStyle: style.menu,
                anchorOrigin: topRight,
                targetOrigin: topRight,
            };

            listItemProps.rightIcon = (
                <IconMenu {...iconMenuProps}
                    iconButtonElement={
                        <IconButton touch={true} >
                            <MoreVertIcon color={statusColours.light} style={style.iconButton} />
                        </IconButton>
                    }
                >
                    {menuItems}
                </IconMenu>
            );
        }

        let avatarIcon = (<SubjectIcon color={iconColor} />);

        switch(row.type) {

            case 'classroom':
                avatarIcon = (<SchoolIcon style={style.icon} color={iconColor} />);
                break;

            case 'e-learning':
                avatarIcon = (<LaunchIcon style={style.icon} color={iconColor} />);
                break;

            case 'video':
                avatarIcon = (<VideoIcon style={style.icon} color={iconColor} />);
                break;

            case 'audio':
                avatarIcon = (<AudioIcon style={style.icon} color={iconColor} />);
                break;

            case 'resource':
                avatarIcon = (<LibraryIcon style={style.icon} color={iconColor} />);
                break;

            default:
                break;
        }

        return (
            <ListItem
                key={row.id}
                style={style.listItem}
                leftAvatar={
                    <Link to={infoLink}>
                        {avatarIcon}
                    </Link>
                }
                {...listItemProps}
            />
        );
    }
});

MyModuleListItem.contextTypes = {
    auth: PropTypes.object.isRequired
};
export default MyModuleListItem;
